import React, { useEffect, useState } from "react";
import { User } from "react-feather";
import { useLazyGetEmployeePhotoBlobQuery } from "../../../masters/employees/employeesApi";

const SIZE = 32;

// Circular avatar photo, matching the reference mockup's guard-row treatment. Only fetches
// when hasPhoto is true (sp_app_guard_roster_candidates already knows this from
// Employee_Images, so most rows skip the request entirely rather than firing one that 404s).
// The photo endpoint streams bytes behind this app's bearer-token auth, so a plain
// <img src="..."> can't reach it - blob fetch + object URL is the only way, same pattern
// already used for employee documents/signatures.
const GuardAvatar = ({ employeeRecordGuid, hasPhoto }) => {
  const [fetchPhoto] = useLazyGetEmployeePhotoBlobQuery();
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    if (!hasPhoto) return undefined;
    let url;
    fetchPhoto(employeeRecordGuid)
      .unwrap()
      .then((blob) => {
        url = URL.createObjectURL(blob);
        setObjectUrl(url);
      })
      .catch(() => setObjectUrl(null));
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeRecordGuid, hasPhoto]);

  if (objectUrl) {
    return (
      <img
        src={objectUrl}
        alt=""
        className="rounded-circle"
        style={{ width: SIZE, height: SIZE, objectFit: "cover" }}
      />
    );
  }

  return (
    <span
      className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-muted"
      style={{ width: SIZE, height: SIZE, flexShrink: 0 }}
    >
      <User size={18} />
    </span>
  );
};

export default GuardAvatar;
